import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root',
})
export class UserlicenseService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) {}

  saveuserLicesneFormData(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'UserLicense/SaveUserLicense',
      data,
    )
  }
  filterData(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'UserLicense/ShowUserLicense',
      data,
    )
  }
}
